import { useMemo } from "react";
import { extractIsotopeKey, findMatchingTrazador } from "../utils/calculationHelpers";

/**
 * Hook para seleccionar el trazador correcto basado en el tipo de isotopo
 */
export const useTrazadorSelector = (isotopeType?: string, trazadoresList: any[] = []) => {
  return useMemo(() => {
    if (!isotopeType || trazadoresList.length === 0) return null;
    
    const isotopeKey = extractIsotopeKey(isotopeType);
    return findMatchingTrazador(trazadoresList, isotopeKey);
  }, [trazadoresList, isotopeType]);
};
